/* eslint-disable react/prop-types */
/* eslint-disable react/display-name */
import React from 'react';
import { FaCheck } from 'react-icons/fa';
import { FiX } from 'react-icons/fi';
import { IConversationOptions, IConversationMessage } from 'src/types/serviceResponseTypes';
import RadioButton from '../../RadioButton/RadioButton';
import styles from './ChoiceLeftSide.module.scss';

// Memoized Left Side Component (Radio/Checkbox or Icons)
const ChoiceLeftSide = React.memo<{
  choice: IConversationOptions;
  conversation: IConversationMessage;
  isMultiChoice: boolean;
  userSelection: string[] | undefined;
  isCorrect: boolean;
  showSelectedState: boolean;
  onUserSelection: (choice: IConversationOptions) => void;
  inputName?: string;
  inputId?: string;
  inputRef?: React.Ref<HTMLInputElement>;
  choiceLabledby?: string;
}>(({
  choice,
  conversation,
  isMultiChoice,
  userSelection,
  isCorrect,
  showSelectedState,
  onUserSelection,
  inputName,
  inputId,
  inputRef,
  choiceLabledby
}) => {
  // Correct: filled green 20px circle + white tick, centred in a 24px slot (Figma)
  const correctMark = (
    <span className={styles.indicatorSlot} aria-hidden={true}>
      <span className={styles.correctIndicator}>
        <FaCheck size={11} className='text-white' aria-hidden={true} focusable={false} />
      </span>
    </span>
  );

  if (showSelectedState) {
    // Show check or cross icon for selected choices
    return isCorrect ? (
      correctMark
    ) : (
      <span className={styles.indicatorSlot} aria-hidden={true}>
        <span className={styles.incorrectIndicator}>
          <FiX size={14} strokeWidth={3} className='text-white' aria-hidden={true} focusable={false} />
        </span>
      </span>
    );
  }

  if (isCorrect) {
    // Correct answer revealed — same filled green mark
    return correctMark;
  }

  // Show radio/checkbox for selectable choices
  return (
    <RadioButton
      id={inputId}
      inputRef={inputRef}
      choiceLabledby={choiceLabledby}
      inputName={inputName}
      isChecked={userSelection?.includes(choice.key)}
      handleRadioSelect={() => onUserSelection(choice)}
      isDisabled={conversation.locked}
      isMultiSelect={isMultiChoice}
    />
  );
}, (prevProps, nextProps) => {
  return (
    prevProps.choice.key === nextProps.choice.key &&
    prevProps.userSelection === nextProps.userSelection &&
    prevProps.isCorrect === nextProps.isCorrect &&
    prevProps.showSelectedState === nextProps.showSelectedState &&
    prevProps.conversation.locked === nextProps.conversation.locked
  );
});

export default ChoiceLeftSide;